import React from "react"
import * as R from "ramda"

import BasicPageLift from "./basicPageLift"
import BasicPageParagraph from "./basicPageParagraph"
import BasicPageAccordion from "./basicPageAccordion"
import BasicPageLinkList from "./basicPageLinkList"
import RichText from "../components/richText"


import Box from "@material-ui/core/Box"

const getElement = section => {
  const richTextContent = R.path(["richText"], section)
  const language = R.path(["node_locale"], section)

  if (R.path(["__typename"], section) === "ContentfulPerusalasivunosto") {
    return (
      <Box style={{ marginBottom: "30px" }} key={R.path(["title"], section)}>
        <BasicPageLift pageContent={section} language={language} />
      </Box>
    )
  }
  if (
    R.path(["__typename"], section) === "ContentfulPerusalasivunTekstikappale"
  ) {
    return (
      <Box key={R.path(["title"], section)}>
        <BasicPageParagraph pageContent={section} language={language} />
        {richTextContent && <RichText richText={richTextContent} />}
      </Box>
    )
  }
  if (R.path(["__typename"], section) === "ContentfulHaitarielementti") {
    return (
      <Box style={{ marginBottom: "80px" }} key={R.path(["title"], section)}>
        <BasicPageAccordion pageContent={section} />
      </Box>
    )
  }
  if (R.path(["__typename"], section) === "ContentfulLinkkilista") {
    return (
      <Box style={{ marginBottom: "80px" }} key={R.path(["title"], section)}>
        <BasicPageLinkList pageContent={section} />
      </Box>
    )
  }
}

const BasicPageReferences = ({ pageContent }) => {
  const references = R.path(["contentArea"], pageContent)

  return references
    ? !Array.isArray(references)
      ? getElement(references)
      : references.map(reference => getElement(reference))
    : null
}

export default BasicPageReferences
